import { render, staticRenderFns } from "./CertificadosAsignarEncuesta.vue?vue&type=template&id=96187098&scoped=true"
import script from "./CertificadosAsignarEncuesta.vue?vue&type=script&lang=js"
export * from "./CertificadosAsignarEncuesta.vue?vue&type=script&lang=js"
import style0 from "./CertificadosAsignarEncuesta.vue?vue&type=style&index=0&id=96187098&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96187098",
  null
  
)

export default component.exports